import { useTranslation } from 'react-i18next';

import { CheckboxInABox } from 'components/Form/Checkbox/Checkbox';

export const DontShowAgainCheckbox = ({
  checked,
  setChecked,
}: {
  checked: boolean;
  setChecked: (checked: boolean) => void;
}) => {
  const { t } = useTranslation();
  return (
    <CheckboxInABox
      checked={checked}
      onChange={(e) => setChecked(e.target.checked)}
      label={t('common:dontShowAgain.label')}
      description={undefined}
    />
  );
};
